import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { CookieStorage } from './storage/cookie-storage';
import { ConfigStorage } from './storage/config-storage';
import { validateExternalApi } from './lib/utils';
import { ConsentPolicyCategories } from './types';
import { DEFAULT_CACHE_TTL } from './constants';
export class MainBsiManager {
  constructor(options) {
    this.options = options;
    _defineProperty(this, "api", void 0);
    _defineProperty(this, "cookie", void 0);
    _defineProperty(this, "config", void 0);
    _defineProperty(this, "consentPolicyChangedListener", void 0);
    _defineProperty(this, "initialized", false);
    _defineProperty(this, "session", void 0);
    _defineProperty(this, "ttlTimeout", void 0);
  }
  static create(api, options) {
    return new MainBsiManager(options).init(api);
  }
  isCachedSessionValid(session, pageNumber) {
    const currentPolicy = this.config.getPolicy();
    return Date.now() < session.cacheExpires && session.pageNumber === pageNumber && [ConsentPolicyCategories.Analytics, ConsentPolicyCategories.Functional].every(category => {
      var _session$policy, _currentPolicy$policy;
      return ((_session$policy = session.policy) == null ? void 0 : _session$policy[category]) === (currentPolicy == null || (_currentPolicy$policy = currentPolicy.policy) == null ? void 0 : _currentPolicy$policy[category]);
    });
  }
  createSessionObject(pageNumber, bsiString, prevSessionObject) {
    var _getPolicy, _this$options;
    if (bsiString === void 0) {
      bsiString = null;
    }
    const [bsi = this.api.generateGuid(), pn = '1'] = bsiString ? bsiString.split('|') : [];
    const {
      baseGlobalPageNumber = parseInt(pn, 10),
      baseSessionPageNumber = pageNumber
    } = prevSessionObject || {};
    const sessionPageNumber = baseGlobalPageNumber + pageNumber - baseSessionPageNumber;
    return {
      bsi,
      pageNumber,
      baseGlobalPageNumber,
      baseSessionPageNumber,
      bsiString: `${bsi}|${sessionPageNumber}`,
      policy: {
        ...((_getPolicy = this.config.getPolicy()) == null ? void 0 : _getPolicy.policy)
      },
      cacheExpires: Date.now() + (((_this$options = this.options) == null ? void 0 : _this$options.cacheTtl) ?? DEFAULT_CACHE_TTL)
    };
  }
  extend(session) {
    const {
      bsiString,
      pageNumber
    } = session;

    // Set cookie
    const {
      bsi: actualBsiString,
      ttl
    } = this.cookie.set(bsiString);

    // Update commonConfig and trigger subscribers
    this.config.set(actualBsiString);
    this.session = {
      ...session,
      bsiString: actualBsiString
    };
    clearTimeout(this.ttlTimeout);
    if (ttl) {
      // Simulate activity after the cookie expires so we always have a valid bsi value
      this.ttlTimeout = setTimeout(() => this.extend(this.createSessionObject(pageNumber)), ttl);
    }
    return actualBsiString;
  }
  createOrExtendSession(pageNumber) {
    if (pageNumber === void 0) {
      pageNumber = 1;
    }
    const currentBsiString = this.cookie.get() || this.config.get();
    const session = currentBsiString ? this.createSessionObject(pageNumber, currentBsiString, this.session) : this.createSessionObject(pageNumber);
    return this.extend(session);
  }
  init(api) {
    validateExternalApi(api, 'generateGuid', 'getCommonConfig');
    this.api = api;
    this.config = new ConfigStorage(this.api.getCommonConfig, this.api.getConsentPolicy);
    this.cookie = new CookieStorage(this.config, this.api.getCookieReaderWriter);
    this.createOrExtendSession();
    if (globalThis.consentPolicyManager && typeof globalThis.addEventListener === 'function') {
      this.consentPolicyChangedListener = () => {
        this.createOrExtendSession();
      };
      globalThis.addEventListener('consentPolicyChanged', this.consentPolicyChangedListener);
    }
    this.initialized = true;
    return this;
  }
  destroy() {
    clearTimeout(this.ttlTimeout);
    if (this.consentPolicyChangedListener) {
      globalThis.removeEventListener('consentPolicyChanged', this.consentPolicyChangedListener);
    }
  }
  getBsi(pageNumber, _temp) {
    var _this$session;
    if (pageNumber === void 0) {
      pageNumber = 1;
    }
    let {
      extend
    } = _temp === void 0 ? {
      extend: true
    } : _temp;
    if (!this.initialized) {
      throw new Error('bsiManager: please call init() first');
    }
    if (extend) {
      if (this.session && this.isCachedSessionValid(this.session, pageNumber)) {
        return this.session.bsiString;
      }
      return this.createOrExtendSession(pageNumber);
    }
    return ((_this$session = this.session) == null ? void 0 : _this$session.bsiString) ?? null;
  }
}
//# sourceMappingURL=manager-main.js.map